import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles'
import MUIDataTable from "mui-datatables";

const DataTables = (props) => {

    const theme = createTheme({
        components: {
            MUIDataTableBodyRow: {
                styleOverrides:
                {
                    root: {
                        '&:nth-of-type(odd)': {
                            backgroundColor: '#e9ecef'
                        }
                    }
                }
            },
            MUIDataTableBodyCell: {
                styleOverrides:
                {
                    root: {
                        paddingTop:'2px!important',
                        paddingBottom:'2px!important'
                    }
                }
            },
            MuiTablePagination:{
                styleOverrides:
                {
                    select:{
                        marginTop:'-14px!important'
                    }
                }
            },
            MuiSelect:{
                styleOverrides:
                {
                    icon:{
                        marginTop:'-8px!important'
                    }
                }
            }

            
        }
    });
    
    return (
        <ThemeProvider theme={theme}>
            <MUIDataTable data={props.data} columns={props.columns} options={props.options} />
        </ThemeProvider>
    );
}

export default DataTables;